import CachedKeys from 'consts/cachedKeys';
import isObject from 'lodash/isObject';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';
import { useSave } from 'redux/store/StoreCached';
import CacheService from 'services/CacheService';

const { getLoadRouteList } = actions;

let timer = null;
export default () => {
  const save = useSave();
  const dispatch = useDispatch();
  const routes = useSelector((state) => state.othersReducer.listRoute);
  const isFetchedRoute = useSelector((state) => state.othersReducer.isFetchedRoute);
  // const isFetchingRoute = useSelector((state) => state.othersReducer.isFetchingRoute);

  useEffect(() => {
    if (isFetchedRoute) {
      return;
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      dispatch(getLoadRouteList());
    }, 0);
  }, [dispatch, isFetchedRoute]);

  const vendor = useMemo(
    () =>
      isObject(routes)
        ? Object.entries(routes)
            .map(([key, details]) => ({
              ...details,
              k: key,
              label: `${details.id} - ${details.v}`,
              value: details.id,
            }))
            .sort((a, b) => {
              return a.value - b.value;
            })
        : [],
    [routes],
  );

  useEffect(() => {
    save(CachedKeys.LIST_VENDOR, vendor);
  }, [save, vendor]);

  CacheService.set('vendors', vendor);

  return vendor;
};
